var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnualFee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000488281 9.99967C-0.000488281 4.47633 4.47633 -0.000488281 9.99967 -0.000488281C15.523 -0.000488281 19.9998 4.47633 19.9998 9.99967C19.9998 15.523 15.523 19.9998 9.99967 19.9998C4.47633 19.9998 -0.000488281 15.523 -0.000488281 9.99967ZM13.7486 6.25078C13.4765 5.97752 13.0346 5.97752 12.7625 6.25078L6.25078 12.7625C5.97752 13.0346 5.97752 13.4765 6.25078 13.7486C6.52287 14.0218 6.96474 14.0218 7.23684 13.7486L13.7486 7.23684C14.0218 6.96474 14.0218 6.52287 13.7486 6.25078ZM7.67406 8.6043C8.18802 8.6043 8.6043 8.18802 8.6043 7.67406C8.6043 7.16009 8.18802 6.74381 7.67406 6.74381C7.16009 6.74381 6.74381 7.16009 6.74381 7.67406C6.74381 8.18802 7.16009 8.6043 7.67406 8.6043ZM13.2555 12.3253C13.2555 12.8393 12.8393 13.2555 12.3253 13.2555C11.8113 13.2555 11.395 12.8393 11.395 12.3253C11.395 11.8113 11.8113 11.395 12.3253 11.395C12.8393 11.395 13.2555 11.8113 13.2555 12.3253Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualFee);
export default __webpack_public_path__ + "static/media/annual-fee.d725a0deb602aac836c99a0ca95ac0f2.svg";
export { ForwardRef as ReactComponent };